export default function stopPropagation(e?: {stopPropagation: () => void}) {
    e?.stopPropagation();
}
